import { CELL_H, GRID_ROWS, PLAY_MARGIN_TOP } from './Playfield';

export interface VisibleRowRange {
  startRow: number;  // inclusive
  endRow: number;    // inclusive
}

/**
 * Rows whose hole centers fall in [scrollY, scrollY + viewportHeight], padded by
 * `bufferRows` on each side. Clamped to [0, GRID_ROWS-1].
 *
 * Why: pool-based hole rendering only spawns sprites for rows in the window; rows
 * outside the window get zero per-frame cost.
 */
export function computeVisibleRowRange(
  scrollY: number,
  viewportHeight: number,
  bufferRows: number,
): VisibleRowRange {
  const topRow = Math.floor((scrollY - PLAY_MARGIN_TOP) / CELL_H);
  const botRow = Math.floor((scrollY + viewportHeight - PLAY_MARGIN_TOP) / CELL_H);
  const startRow = Math.max(0, Math.min(GRID_ROWS - 1, topRow - bufferRows));
  const endRow = Math.max(startRow, Math.min(GRID_ROWS - 1, botRow + bufferRows));
  return { startRow, endRow };
}
